// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"55eaf47c","1519":"3b17df63","4928":"55eaf47c","9237":"65870245"}[chunkId] + ".chunk.css";
};